import React from 'react';
import PropTypes from 'prop-types';

import {Title, Box} from 'views/components';
import {Translate} from 'views/module';

const JobNameView = (props) => {
  const {
    jobData,
    client,
  } = props;

  return (
    <Box>
      <Title disableDivider sx={{my: '8px', fontWeight: 'bold'}}>
        <Translate
          expression="career.jobDetail.Title"
          substitute={{
            clientName: client?.clientDetail?.clientName || jobData.client?.unregisteredClient || 'Unknown Client',
            neighborhood: jobData.location.neighborhood,
            city: jobData.location.city,
          }}
        />
      </Title>
    </Box>
  );
};

JobNameView.propTypes = {
  jobData: PropTypes.object.isRequired,
  client: PropTypes.object,
};

export default React.memo(JobNameView);
